import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import config from 'config'
import {
  ContainerDivs,
  RetirementPlanListFFF,
  Link,
  LinkIcon
} from '../../components'
import Styles from './Banner401k.css'

@CSSModules(Styles,{allowMultiple:false})
export default class Banner401k extends Component {
  render() {
    return (
      <div styleName='hh-img-bckgrnd'>
        <div styleName='hh-img-bckgrnd-gray'>
          <ContainerDivs>
            <h1 styleName='hh-hl'>
              Your retirement plan may be fueling the climate crisis. But it
              doesn't have to.
            </h1>

            { /* <div styleName='hh-tl'>
              See how 401(k)s or similar employee retirement plans of S&P 500
              companies are rated on seven environmental and social
              sustainability issues.
            </div> */ }

            <RetirementPlanListFFF />

            <div styleName='hh-button'>
              <Link
                to={config.links.iyv}
                title='Retirement plan sustainability scorecard'
                bigbutton
              >
                InvestYourValues.org<LinkIcon />
              </Link>
            </div>

          </ContainerDivs>
        </div>
      </div>
    )
  }
}

